import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SignUpButton from '../../layout/navbar/sign-up-button';

const Container = styled.div`
  background-color: #1E2737;
  width: 100%;
  padding: 24px 20px 90px;
`;

const Img = styled.img`
  height: 360px;
  max-height: 360px;
  width: 100%;
  object-fit: cover;
  margin-bottom: 40px;
`;

const Headline = styled.div`
  color: ${props => props.theme.bodyBackgroundColor};
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 40px;
  line-height: 120%;
  margin-bottom: 16px;
`;

const Byline = styled.div`
  color: ${props => props.theme.bodyBackgroundColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightRegular};
  font-size: 19px;
  line-height: 130%;
`;

const ButtonContainer = styled.div`
  margin-top: 40px;
  width: 100%;
`;

const Link = styled.a`
  color: ${props => props.theme.bodyBackgroundColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 34px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-left: 20px;
  vertical-align: bottom;

  &:hover {
    color: ${props => props.theme.bodyBackgroundColor};
    cursor: pointer;
  }
`;

export default function Tablet({ banner, signUpUrl, signInUrl }) {
  const {
    imageUrl,
    headline,
    byline,
    registerButtonCopy,
  } = banner;

  return (
    <Container>
      <Img src={imageUrl} />
      <Headline>{headline}</Headline>
      <Byline>{byline}</Byline>
      <ButtonContainer>
        <SignUpButton label={registerButtonCopy} signUpUrl={signUpUrl} />
        <Link href={signInUrl}>Sign In</Link>
      </ButtonContainer>
    </Container>
  );
}

Tablet.propTypes = {
  banner: PropTypes.shape({
    id: PropTypes.number.isRequired,
    headline: PropTypes.string.isRequired,
    byline: PropTypes.string,
    imageUrl: PropTypes.string.isRequired,
    registerButtonCopy: PropTypes.string,
  }).isRequired,
  signUpUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
};
